import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Button } from '@gsa/afp-component-library';
import { useSolicitationActions } from '../components/apis/use-solicitation-actions';

const ReactivateSolicitationButton = ({ solicitation, ...rest }) => {
  const navigate = useNavigate();
  const { reactivateSolicitation, reactivateLoading } = useSolicitationActions({
    onCompleted: () => navigate('/catalog/solicitations'),
  });

  const onClick = () => {
    reactivateSolicitation({
      variables: {
        id: Number(solicitation.id),
      },
    });
  };

  return (
    <Button
      variant="secondary"
      label="Reactivate"
      disabled={reactivateLoading}
      onClick={onClick}
      {...rest}
    />
  );
};

ReactivateSolicitationButton.propTypes = {
  solicitation: PropTypes.shape({
    id: PropTypes.string,
    solicitationNumber: PropTypes.string,
  }).isRequired,
};

export default ReactivateSolicitationButton;
